import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import React, { useEffect, useState} from "react";
import { AgGridReact } from "ag-grid-react";
import { TopBar } from "../../shared/topBar/TopBar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { UrlPath } from "../../../config/routeConfig";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Tolerance } from "../MonitoringExceptionSettings/Tolerance";
import { MonitoringExceptionType } from "../MonitoringExceptionSettings/MonitoringExceptionType";
import { MonitoringNotificationDetails } from "../MonitoringExceptionSettings/MonitoringNotificationDetails";
import { ToastContainer, toast } from 'react-toastify';
export const MonitoringSettingsView = () => {
    
    const Level = [{ BreadCrumb: "Admin >", Routes: UrlPath.Admin },{ BreadCrumb: "Monitoring Exception Settings",Routes: UrlPath.MonitoringExceptionSettings }];

    useEffect(() => {
        document.title = `Monitoring Exception`;
    }, []);
    const options = [
        { value: "0", label: "Exceptions" },
        { value: "1", label: "ExceptionType" },
        { value: "2", label: "Tolerance" },
        { value: "3", label: "NotificationTypes" }

    ];

    const history = useNavigate();
    const locationData = useLocation();
  

    const [selectedTabOption, setSelectedTabOption] = useState("ExceptionType");
    const handleTabChange = (eventKey) => {
        setSelectedTabOption(eventKey);
    };
    const previouslyActiveTab =
        locationData.state === null
            ? "ExceptionType"
            : locationData.state.ActiveTab;
    
    return <>

        <div>
            <TopBar label={"Monitoring Exceptions"} />
            <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="p-4" mb-5>
                <Tabs
                    defaultActiveKey={previouslyActiveTab}
                    id="uncontrolled-tab-example"
                    className="ms-3"
                    onSelect={handleTabChange}
                >
                        <Tab eventKey="ExceptionType" title="Exception Type" >
                           {selectedTabOption=="ExceptionType" && <>
                           <div className="detail border-top-0 p-3">
                           <MonitoringExceptionType/>                                                     
                           </div>
                           </>}
                        </Tab>
                        <Tab eventKey="Tolerance" title="Tolerance" >
                        {selectedTabOption=="Tolerance" && <>
                        <div className="detail border-top-0 p-3">
                           <Tolerance/>     
                           </div>                     
                           </>}
                           
                        </Tab>
                        <Tab eventKey="NotificationTypes" title="Notification Type" >
                        {selectedTabOption=="NotificationTypes" && <>
                        <div className="detail border-top-0 p-3">
                           <MonitoringNotificationDetails/>   
                           </div>                       
                           </>}
                        </Tab>
                </Tabs>
            </div>
           
           
           
           

            </div>
            <ToastContainer></ToastContainer>
        </div>
    </>

}


  